export const LOADING = 'carrier/LOADING';
export const MESSAGE = 'carrier/MESSAGE';
export const SET_CARRIERS = 'carrier/SET_CARRIERS';
export const SET_CARRIER = 'carrier/SET_CARRIER';